import { render, staticRenderFns } from "./FIBModal.vue?vue&type=template&id=b470d788&scoped=true&"
import script from "./FIBModal.vue?vue&type=script&lang=js&"
export * from "./FIBModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b470d788",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});qInstall(component, 'directives', {ClosePopup});
